import http from "../utils/http";
import crypto from "../utils/crypto";

/**
 * [修复] 移除了未使用的 store 导入和注释掉的代码
 * 原因：保持代码简洁，移除无用代码
 */

// 新增发票记录
export function insertData(params) {
  return http.post("/api/CheckInvoice/AddInvoice", params);
}

// 删除发票记录
export function delData(params) {
  return http.delete("/api/CheckInvoice/DelInvoice?number=" + params);
}

// 查询发票信息
export function getData(params) {
  const url = `/api/CheckInvoice/InvoiceInfo?code=${params.code}&number=${params.number}`;
  return http.get(url);
}

// 查询发票记录
export function queryInvoiceRecord(params) {
  const url = `/api/CheckInvoice/QueryInvoiceRecord?date=${params.date}&unit=${params.unit}&type=${params.type}`;
  return http.get(url);
}

/**
 * [安全改进] 用手机号验证码登录
 * 传递加密后的手机号和验证码
 */
export function loginByPhoneAndCode(params) {
  // 对手机号进行加密
  const encryptedData = {
    mobile: crypto.encryptPhone(params.mobile),
    code: params.code,
    rememberMe: params.rememberMe || false,
    browser: params.browser || "",
    os: params.os || "",
    deviceInfo: params.deviceInfo || "",
  };
  console.log("登录请求 - 原始手机号:", params.mobile);
  console.log("登录请求 - 加密后手机号:", encryptedData.mobile);
  console.log("登录请求 - 验证码:", encryptedData.code);
  console.log("登录请求 - 记住我:", encryptedData.rememberMe);
  return http.post("/api/user/LoginByPhoneAndCode", encryptedData);
}

/**
 * [安全改进] 发送验证码
 * 1. 改为 POST 请求（避免手机号暴露在 URL 中）
 * 2. 手机号加密后传输
 * @param {object} params - { phoneNo: '手机号' }
 */
export function getPhoneCode(params) {
  // 对手机号进行加密
  const encryptedPhone = crypto.encryptPhone(params.phoneNo);
  // [调试] 打印加密前后的手机号
  console.log("原始手机号:", params.phoneNo);
  console.log("加密后手机号:", encryptedPhone);
  // [调试] 验证解密是否正确
  console.log("解密验证:", crypto.decryptPhone(encryptedPhone));
  // 使用 POST 请求，加密数据放在请求体中
  return http.post("/api/user/GetPoneCode", { phone: encryptedPhone });
}

/**
 * [修复] login/validate/fetchPermission 函数原来使用 axios 直接调用
 * 原因：应该统一使用 http 封装，确保请求拦截器正确添加 token
 */
// 登录
export function login(user) {
  return http.post("/api/User/login", user);
}

// 验证登录
export function validate() {
  return http.get("/api/User/Validate");
}

// 获取用户权限
export function fetchPermission() {
  return http.get("/api/User/GetUserPermission");
}

// 获取用户菜单权限
export function getUserMenus() {
  return http.get("/api/User/GetUserMenus");
}

// 获取用户单位信息
export function getUserUnitInfo() {
  return http.get("/api/User/GetUserUnitInfo");
}

export default {};